import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Overlay } from "react-overlays";
import styles from "./Dropdown.scss";
import { ArrowDownFillIcon } from "~/theme/assets";

export function DropdownItem({ children, value, currentValue, onChange }) {
  return (
    <div
      onClick={() => onChange(value)}
      className={classnames({
        [styles.selected]: currentValue === value,
      })}>
      {children}
    </div>
  );
}

function DropdownCurrent({ value, isLanguage }) {
  let Elem = <div>{value}</div>;

  if (isLanguage) {
    Elem = <span className={styles.flag + " " + styles[value]} alt={value} />;
  }

  return Elem;
}

class Dropdown extends Component {
  constructor(props) {
    super(props);

    // Binding
    this.handleOnHide = this.handleOnHide.bind(this);
    this.handleOnShow = this.handleOnShow.bind(this);
    this.handleOnChange = this.handleOnChange.bind(this);

    this.state = {
      show: false,
    };
  }

  handleOnHide() {
    this.setState({
      show: false,
    });
  }

  handleOnShow() {
    this.setState({
      show: true,
    });
  }

  handleOnChange(value) {
    this.props.onChange(value);
    this.handleOnHide();
  }

  render() {
    const {
      value,
      label,
      currentContainer,
      children,
      onChange,
      className,
      isLanguage,
      hideArrow,
      placement,
      CustomArrowDown,
      ...otherProps
    } = this.props;

    return (
      <div className={classnames("wbkv9-Dropdown", "row", "dropdown", className)} {...otherProps}>
        <div
          className={classnames("row Dropdown--Header wbkv9-Dropdown-Header")}
          ref={element => (this._dropdown = element)}
          onClick={this.handleOnShow}>
          {value !== undefined && isLanguage && (
            <div className={classnames(styles.current)}>
              {React.cloneElement(currentContainer, { value, isLanguage })}
            </div>
          )}

          {label && <div>{label}</div>}

          {!hideArrow && !CustomArrowDown && (
            <div className="icon">
              <ArrowDownFillIcon />
            </div>
          )}

          {!hideArrow && CustomArrowDown && <div>{CustomArrowDown}</div>}
        </div>
        <Overlay
          placement={placement || "bottom-start"}
          onHide={this.handleOnHide}
          show={this.state.show}
          container={this}
          target={() => this._dropdown}
          rootClose>
          {({ props }) => (
            <div className={classnames("Dropdown--Overlay", styles.overlay)} {...props}>
              {React.Children.toArray(children)
                .filter(child => child.type === DropdownItem)
                .map(child =>
                  React.cloneElement(child, {
                    onChange: this.handleOnChange,
                    currentValue: value,
                  })
                )}
            </div>
          )}
        </Overlay>
      </div>
    );
  }
}

Dropdown.propTypes = {
  value: PropTypes.any.isRequired,
  label: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.object,
  currentContainer: PropTypes.element.isRequired,
  onChange: PropTypes.func.isRequired,
  isLanguage: PropTypes.bool,
  hideArrow: PropTypes.bool,
  placement: PropTypes.string,
  CustomArrowDown: PropTypes.object,
};

Dropdown.defaultProps = {
  currentContainer: <DropdownCurrent />,
};

export default Dropdown;
